import "../../../styles/stores/makeTransactions/selectProduct.css";
import { BsSearch, BsCalendarDay, BsArrowRight, BsArrowBarLeft } from "react-icons/bs";
import { toast } from "sonner";
import ProductSelected from "../../../components/ProductSelected";
import { useState, useEffect, useLayoutEffect, useMemo, useRef } from "react";
import NoTransactionSelected from "../../../components/InitailStatesStores/NoTransactionSelected";
import { useSelector, useDispatch } from "react-redux";

import { updateCart, clearCart, setDiscount, setVat, setVatPercentage } from "../../../slice/sellingCarts";
import Spinner from "../../../components/uxCollections/Loaders";
import { naira } from "../stockManagement/AddStockPage";
import { getAllData } from "../../../tools/indexdb";
import { BsUpcScan } from "react-icons/bs";
import ProductToSellCard from "../../../components/productToSellCard/ProductToSellCard";
import ReceiptComponent from "../../../components/POSCartDetail/POSCardDetail";
import BarcodeScanner from "./barCodeScanner/BarCodeScanner";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const SelectProduct = ({ whichCompToRender, setAlertDisplay, getYesterdayTrans, getTodayTrans, getCustomTrans }) => {
  const [productToSell, setProductToSell] = useState([]);
  const [productToSellCopy, setProductToSellCopy] = useState([]);
  const [sellingCart, setSellingCart] = useState([]);
  const [cartTotal, setCartTotal] = useState("");
  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);
  const { cartItem, total } = useSelector((state) => state.sellingCart);
  const [isLoading, setIsLoading] = useState(true); //
  const [viewSelectedProducts, setViewSelectedProducts] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [scanCode, setScanCode] = useState(false);
  const [scanCodeString, setScanCodeString] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [viewPOSDetails, setViewPOSDetails] = useState(false);
  const [openScannerModal, setOpenScannerModal] = useState(false);
  const [vatRate, setVatRate] = useState(store?.vatPercentage ? parseFloat(store.vatPercentage.$numberDecimal) : 0);

  const [vatAmount, setVatAmount] = useState(0);
  const [visibleCount, setVisibleCount] = useState(20);

  const superMarketMode = store?.superMarketMode || false;
  const ref = useRef();
  const tickingRef = useRef(false);
  const alertShownRef = useRef(false);

  useEffect(() => {
    if (!store.isVATenabled) {
      setVat(0);
    }
  }, []);

  const dispatch = useDispatch();
  const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);

  const logSavedData = async () => {
    setIsLoading(true);
    let { storeProductCollection } = await getAllData(store?.storeName);

    if (!storeProductCollection.length) {
      setAlertDisplay({
        showAlert: true,
        type: "error",
        title: "No product found",
        message: "You have not created any product yet",
      });
    }
    //this is where to create a new product subunit
    const expanded = expandProductsWithSubUnits(storeProductCollection);

    /* setProductToSell(storeProductCollection);
    setProductToSellCopy(storeProductCollection); */
    setProductToSell(expanded);
    setProductToSellCopy(expanded);
    setIsLoading(false);
  };

  useLayoutEffect(() => {
    cartItem.length > 0 && setSellingCart(cartItem);
    total && setCartTotal(total);
    // fetchProducts();

    /* log indexes data */
    logSavedData();
    if (cartItem.length > 0) {
      setSellingCart(cartItem);
      setCartTotal(total);
    }

    // Calculate VAT amount whenever subtotal or vatRate changes
    const subtotal = sellingCart.reduce((acc, item) => acc + item.soldUnitPrice * item.soldQuantity, 0);
    const calculatedVatAmount = store.isVATenabled ? (subtotal * vatRate) / 100 : 0;

    setVatAmount(calculatedVatAmount);
  }, []);

  useEffect(() => {
    // Recalculate VAT amount whenever vatRate or sellingCart changes
    const subtotal = sellingCart.reduce((acc, item) => acc + item.soldUnitPrice * item.soldQuantity, 0);
    const calculatedVatAmount = store.isVATenabled ? (subtotal * vatRate) / 100 : 0;
    setVatAmount(calculatedVatAmount);
  }, [vatRate, sellingCart]);

  useEffect(() => {
    let total = sellingCart.reduce((acc, item) => {
      acc = acc + item.totalPrice;
      return acc;
    }, 0);

    let targetDiv = document.querySelector(".SelIChecjListDiv");
    onProductSelectedFun(targetDiv);

    setCartTotal(total);
  }, [sellingCart]);

  useEffect(() => {
    if (scanCodeString === "") {
      //reset to defaut product listing
      setProductToSell(productToSellCopy);
    }
  }, [scanCodeString]);

  const handleMobileScan = (scanCodeString) => {
    try {
      let scannedProduct = productToSellCopy.filter((product) => String(product.scannedID?.toLowerCase()) === String(scanCodeString.toLowerCase()));

      if (scannedProduct.length === 0) {
        // optional: show an alert for unknown barcode
        toast.error("No product found for scanned code:" + scanCodeString);
        setScanCodeString("");
        return;
      }

      if (superMarketMode) {
        console.log("supermarket mode active");

        // in supermarket mode, add to cart directly
        if (scannedProduct.length > 0) {
          let newCart = sellingCart.filter((item) => item._id === scannedProduct[0]._id);
          if (newCart.length > 0) {
            console.log("already in cart so increase the quantity");
            let updatedCart = sellingCart.map((item) => {
              if (item._id === scannedProduct[0]._id) {
                //check if product quantity is available
                if (Number(item.soldQuantity) + 1 > Number(item.quantity) - Number(item.damagedAmount)) {
                  setAlertDisplay({
                    showAlert: true,
                    type: "error",
                    title: "Insufficient stock",
                    message: `You only have ${Number(item.quantity) - Number(item.damagedAmount)} unit(s) of ${item.name} available in stock`,
                  });
                  return item; // return the item without updating
                }
                return {
                  ...item,
                  soldQuantity: item.soldQuantity + 1,
                  totalPrice: (item.soldQuantity + 1) * item.soldUnitPrice,
                };
              }
              return item;
            });
            setSellingCart(updatedCart);
          } else {
            console.log("not in cart");
            setSellingCart([
              ...sellingCart,
              { ...scannedProduct[0], soldQuantity: 1, totalPrice: Number(scannedProduct[0].unitPrice), soldUnitPrice: Number(scannedProduct[0].unitPrice) },
            ]);
          }
        }
        setScanCodeString("");
      } else {
        setProductToSell(scannedProduct);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyDown = (e = {}, mobileScanner = false) => {
    const key = (e && e.key) || (mobileScanner ? "Enter" : null);
    if (key === "Enter" || key === "Tab" || mobileScanner) {
      console.log("enter key pressed");

      if (e.preventDefault) e.preventDefault();
      let scannedProduct = productToSellCopy.filter((product) => String(product.scannedID?.toLowerCase()) === String(scanCodeString.toLowerCase()));

      if (scannedProduct.length === 0) {
        // optional: show an alert for unknown barcode
        console.log("No product found for scanned code:", scanCodeString);
        setScanCodeString("");
        return;
      }

      if (superMarketMode) {
        console.log("supermarket mode active");

        // in supermarket mode, add to cart directly
        if (scannedProduct.length > 0) {
          let newCart = sellingCart.filter((item) => item._id === scannedProduct[0]._id);
          if (newCart.length > 0) {
            console.log("already in cart so increase the quantity");
            let updatedCart = sellingCart.map((item) => {
              if (item._id === scannedProduct[0]._id) {
                //check if product quantity is available
                if (Number(item.soldQuantity) + 1 > Number(item.quantity) - Number(item.damagedAmount)) {
                  setAlertDisplay({
                    showAlert: true,
                    type: "error",
                    title: "Insufficient stock",
                    message: `You only have ${Number(item.quantity) - Number(item.damagedAmount)} unit(s) of ${item.name} available in stock`,
                  });
                  return item; // return the item without updating
                }
                return {
                  ...item,
                  soldQuantity: item.soldQuantity + 1,
                  totalPrice: (item.soldQuantity + 1) * item.soldUnitPrice,
                };
              }
              return item;
            });
            setSellingCart(updatedCart);
          } else {
            console.log("not in cart");
            setSellingCart([
              ...sellingCart,
              { ...scannedProduct[0], soldQuantity: 1, totalPrice: Number(scannedProduct[0].unitPrice), soldUnitPrice: Number(scannedProduct[0].unitPrice) },
            ]);
          }
        }
        setScanCodeString("");
      } else {
        setProductToSell(scannedProduct);
      }
    }
  };

  const toggleSearchOrScan = (node) => {
    /*     let searchDiv = document.querySelector(".searchProductInputSel"); */
    // if mobile, open scanner modal

    let searchDiv = document.querySelector(".SearODiv464");
    let scanDiv = document.querySelector(".scanProductInputSel");

    if (node === "search") {
      setScanCode(false);
      scanDiv.classList.add("toggleinputtoggle");
      searchDiv.classList.remove("toggleinputtoggle");
      //searchDiv.focus();
    } else {
      setScanCode(true);
      searchDiv.classList.add("toggleinputtoggle");
      scanDiv.classList.remove("toggleinputtoggle");
      // scanDiv.focus();
    }
  };
  const resetSearch = () => {
    if (productToSellCopy.length === 0) {
      // check if there is no product in the list. No need to reset
      return;
    }
    setProductToSell(productToSellCopy);
    setSearchString("");
    setScanCodeString("");
    setScanCode(false);
    let searchDiv = document.querySelector(".SearODiv464");
    let scanDiv = document.querySelector(".scanProductInputSel");
    scanDiv.classList.add("toggleinputtoggle");
    searchDiv.classList.remove("toggleinputtoggle");
  };

  const addToCartFun = (product) => {
    let newCart = sellingCart.filter((item) => item._id === product._id);
    if (newCart.length > 0) {
      console.log("already in cart");
    } else {
      console.log("not in cart");
      setSellingCart([...sellingCart, product]);
    }
  };

  const removeFromCartFun = (product) => {
    let newCart = sellingCart.filter((item) => item._id !== product._id);

    setSellingCart(newCart);
    /* let selectedProductCart = {
      cart: newCart,
      total: cartTotal,
    };
    dispatch(updateCart(selectedProductCart)); */
  };

  const handleSelectedProduct = () => {
    let selectedProductCart = {
      cart: sellingCart,
      total: cartTotal,
    };
    dispatch(updateCart(selectedProductCart));
    dispatch(setDiscount({ discountAmount }));
    dispatch(setVat({ vat: vatAmount }));
    dispatch(setVatPercentage({ vatPercentage: vatRate }));
    whichCompToRender("FinalProductCheck");
  };

  const onProductSelectedFun = (targetDiv) => {
    if (targetDiv) {
      const wave = document.createElement("span");
      wave.classList.add("wave");
      // Append wave to the target div
      targetDiv.appendChild(wave);
      // Remove wave after animation ends
      setTimeout(() => {
        wave.remove();
      }, 800);
    }
  };

  const openScanner = () => {
    setOpenScannerModal(true);
  };

  /* let ticking = false;
  const handleScroll = (e) => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      if (visibleCount >= productToSell.length) return;

      const { scrollTop, scrollHeight, clientHeight } = e.target;

      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isNearBottom && visibleCount > 150) {
        uiAlert("Please search the product, more items can't be rendered", "info");
        return;
      }
      if (isNearBottom) {
        setVisibleCount((prev) => prev + 40);
      }
      ticking = false;
    });
  }; */

  const handleScroll = (e) => {
    if (tickingRef.current) return;

    const target = e.currentTarget;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    tickingRef.current = true;

    requestAnimationFrame(() => {
      try {
        const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;

        if (!isNearBottom) return;

        setVisibleCount((prev) => {
          if (prev >= productToSell.length) return prev;

          if (prev >= 80) {
            if (!alertShownRef.current) {
              alertShownRef.current = true;
              uiAlert("Please search the product, more items can't be rendered", "info");
            }

            return prev;
          }

          return Math.min(prev + 20, productToSell.length);
        });
      } finally {
        tickingRef.current = false;
      }
    });
  };

  return (
    <>
      <div className='selectProductDivMain'>
        <div className='SelectProducWrapperDiv1'>
          <div>
            <div className='SearchProductDivandScan'>
              <div className='SearODiv464'>
                <span>
                  {" "}
                  <BsSearch />{" "}
                </span>
                <input
                  value={searchString}
                  className='searchProductInputSel '
                  onChange={(e) => {
                    setSearchString(e.target.value);
                    let filteredProducts = productToSellCopy.filter((product) => {
                      return product.name.toLowerCase().includes(e.target.value.toLowerCase());
                    });
                    setProductToSell(filteredProducts);
                  }}
                  placeholder='Search product'
                />{" "}
              </div>
              {isMobileDevice ? (
                <button style={{ display: "flex " }} onClick={() => openScanner()} className='scanProductBtnMobile'>
                  <BsUpcScan size={20} color='#0e49b5' />
                </button>
              ) : (
                <>
                  <button onClick={() => openScanner()} className='scanProductBtnMobile'>
                    <BsUpcScan size={20} color='#0e49b5' />
                  </button>

                  {scanCode ? (
                    <button onClick={() => toggleSearchOrScan("search")} className='scanProductButton'>
                      <BsSearch size={20} color='#0e49b5' />
                      Enter name
                    </button>
                  ) : (
                    <button onClick={() => toggleSearchOrScan("Scan code")} className='scanProductButton'>
                      <BsUpcScan size={20} color='#0e49b5' />
                      Scan code
                    </button>
                  )}
                </>
              )}

              {!isMobileDevice && (
                <input
                  value={scanCodeString}
                  onKeyDown={(e) => handleKeyDown(e)}
                  onInput={(e) => {
                    setScanCodeString(e.target.value);
                  }}
                  className='scanProductInputSel toggleinputtoggle'
                  placeholder='Scan barcode'
                />
              )}
              <div
                style={{
                  margin: "0",
                }}
                onClick={() => sellingCart.length > 0 && setViewPOSDetails(true)}
                className='SelIChecjListDiv disNoneOnMobile'
              >
                <div className='selectedjfus33Div'>
                  {bagSvg}
                  <span>
                    {sellingCart.length} {sellingCart.length > 1 ? "products" : "product"} selected
                  </span>
                  <BsArrowRight size={20} />
                </div>
                {sellingCart.length > 0 && <span className='countICheckedProduct'></span>}
              </div>
            </div>
            {isLoading ? (
              <div>
                {" "}
                <Spinner position={"absolute"} transparent={false} backgroundColor={"#F9F9F9"} />
              </div>
            ) : productToSell?.length > 0 ? (
              <>
                <div className='flexCopy'>
                  <div onScroll={handleScroll} ref={ref} className='selcetProductDivse'>
                    {productToSell.slice(0, visibleCount).map((product, i) => (
                      <ProductToSellCard
                        key={product._id}
                        product={product}
                        addToCart={addToCartFun}
                        removeFromCart={removeFromCartFun}
                        sellingCart={sellingCart}
                        updateCartTotal={setSellingCart}
                      />
                    ))}
                  </div>

                  <div className='productSelectedDiv'>
                    {/*   */}

                    <div onClick={() => sellingCart.length > 0 && setViewSelectedProducts(true)} className='SelIChecjListDiv'>
                      <div className='selectedjfus33Div'>
                        {bagSvg}
                        <span>
                          {sellingCart.length} {sellingCart.length > 1 ? "products" : "product"} selected
                        </span>
                        <BsArrowRight size={20} />
                      </div>
                      {/*  <div>
                        <p>View selected products</p>
                        <BsArrowRight size={20} />
                      </div> */}
                    </div>
                    <div>
                      <ReceiptComponent
                        removeProduct={removeFromCartFun}
                        setDiscount={setDiscountAmount}
                        sellingCart={sellingCart}
                        currency={user.userCountryCurrencySymbol}
                        vatRate={vatRate}
                        setVatRate={setVatRate}
                        vatAmount={vatAmount}
                      />
                      <div className='receirpt-total-div44'>
                        <button
                          onClick={() => {
                            getTodayTrans(true);
                            getYesterdayTrans(false);
                            getCustomTrans(false);
                            whichCompToRender("CashTransactionComp");
                            dispatch(clearCart());
                          }}
                          style={{ cursor: "pointer" }}
                          className='SellsButtonDef'
                        >
                          Cancel
                        </button>
                        {sellingCart.length > 0 ? (
                          <div>
                            <button onClick={() => handleSelectedProduct()} className='SellsButtonDef'>
                              Next
                            </button>
                          </div>
                        ) : (
                          <div>
                            <button disabled style={{ cursor: "not-allowed", opacity: "0.6" }} className='SellsButtonDef'>
                              Next
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/*   ) : (
                    <NoTransactionSelected />
                  )} */}

                  {/* Mobile button here */}
                </div>
                <div className=' mobileSalesActionBar4'>
                  <button disabled={sellingCart.length === 0} onClick={() => handleSelectedProduct()} className='sell-items-btn'>
                    Next
                  </button>
                  <div style={{ width: "100%" }} className='action-left-section'>
                    <button
                      style={{ flex: "1", color: "#214EC7", backgroundColor: "rgba(34, 83, 206, 0.06)", borderColor: "rgba(34, 83, 206, 0.06)" }}
                      className='cancel-sales-btn'
                      onClick={() => {
                        getTodayTrans(true);
                        getYesterdayTrans(false);
                        getCustomTrans(false);
                        whichCompToRender("CashTransactionComp");
                        dispatch(clearCart());
                      }}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className='flexCopy4123'>
                <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424146/static%20images%20storelens/noProductFound_bdcykh.png"} />

                <button onClick={resetSearch}>Return</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {viewSelectedProducts && (
        <div onClick={() => setViewSelectedProducts(false)} className='tranactionDetail'>
          <div onClick={(e) => e.stopPropagation()} style={{ width: "40%", maxWidth: "550px" }} className='transactionListItemsWrapper'>
            <div className='transDetailHeader'>
              <div className='rtjdy63b'>
                <p>Selected Items</p> <p>({sellingCart.length} Items)</p>
              </div>
              <div className='rtjdy63b'>
                {/*  <button className='printTrasDet74'>X3</button> */}
                <button onClick={() => setViewSelectedProducts(false)} className='cloxbtn2321'>
                  X
                </button>
              </div>
            </div>

            {sellingCart.length > 0 ? (
              sellingCart.map((product) => (
                <ProductSelected
                  product={product}
                  removeProduct={removeFromCartFun}
                  updateCartTotal={setSellingCart}
                  sellingCart={sellingCart}
                  currency={user.userCountryCurrencySymbol}
                />
              ))
            ) : (
              <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                {" "}
                <NoTransactionSelected />
              </div>
            )}
          </div>
        </div>
      )}
      {viewPOSDetails && (
        <div onClick={() => setViewPOSDetails(false)} className='tranactionDetail'>
          <div onClick={(e) => e.stopPropagation()} style={{ width: "50%", maxWidth: "550px" }} className='transactionListItemsWrapper'>
            <div className='transDetailHeader'>
              <div className='rtjdy63b'>
                <p>Selected Items</p> <p>({sellingCart.length} Items)</p>
              </div>
              <div className='rtjdy63b'>
                {/*  <button className='printTrasDet74'>X3</button> */}
                <button onClick={() => setViewPOSDetails(false)} className='cloxbtn2321'>
                  X
                </button>
              </div>
            </div>
            <ReceiptComponent
              removeProduct={removeFromCartFun}
              setDiscount={setDiscountAmount}
              sellingCart={sellingCart}
              currency={user.userCountryCurrencySymbol}
              vatRate={vatRate}
              setVatRate={setVatRate}
              vatAmount={vatAmount}
            />
          </div>
        </div>
      )}

      {openScannerModal && (
        <BarcodeScanner setScanCodeString={setScanCodeString} handleProductScan={handleMobileScan} setOpenScannerModal={setOpenScannerModal} />
      )}
    </>
  );
};

export default SelectProduct;

const bagSvg = (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.7939 12.03C4.3309 9.342 4.5999 8 5.4869 7.134C5.65083 6.97444 5.82815 6.82924 6.0169 6.7C7.0399 6 8.4099 6 11.1499 6H12.8529C15.5919 6 16.9609 6 17.9829 6.7C18.1729 6.83067 18.3496 6.97567 18.5129 7.135C19.3999 8 19.6699 9.343 20.2069 12.03C20.9779 15.886 21.3639 17.814 20.4759 19.18C20.3152 19.4287 20.1286 19.6563 19.9159 19.863C18.7499 21 16.7849 21 12.8529 21H11.1499C7.2169 21 5.2509 21 4.0849 19.862C3.87394 19.6556 3.68647 19.4266 3.5259 19.179C2.6379 17.813 3.0239 15.885 3.7959 12.029L3.7939 12.03Z'
      stroke='#0E49B5'
      stroke-width='1.5'
    />
    <path
      d='M9 6V5C9 4.20435 9.31607 3.44129 9.87868 2.87868C10.4413 2.31607 11.2044 2 12 2C12.7956 2 13.5587 2.31607 14.1213 2.87868C14.6839 3.44129 15 4.20435 15 5V6M9.17 15C9.3766 15.5855 9.75974 16.0926 10.2666 16.4512C10.7735 16.8099 11.3791 17.0025 12 17.0025C12.6209 17.0025 13.2265 16.8099 13.7334 16.4512C14.2403 16.0926 14.6234 15.5855 14.83 15'
      stroke='#0E49B5'
      stroke-width='1.5'
      stroke-linecap='round'
    />
  </svg>
);

function expandProductsWithSubUnits(products) {
  return products.flatMap((product) => {
    const result = [product]; // keep original product

    if (product.hasSubUnits && Array.isArray(product.subUnits)) {
      const subUnitProducts = product.subUnits.map((su) => ({
        ...product,
        productId: product._id, // keep original product ID for reference
        _id: `${product._id}-${su.id}`, // create a unique ID for the sub-unit product
        name: `${product.name} (${su.name})`,
        unitPrice: su.sellingPrice,
        costPrice: su.costPrice,
        isSubUnitSold: true,
        subUnitId: su.id,
        unit: su.name,
        quantity: product.quantity * su.conversionFactor + su.quantityOfSubUnitInStock, // calculate available quantity based on parent product
      }));

      result.push(...subUnitProducts);
    }

    return result;
  });
}
